import { render } from "./page-layanan-lainnya.vue?vue&type=template&id=457d3894&scoped=true"
import script from "./page-layanan-lainnya.vue?vue&type=script&lang=js"
export * from "./page-layanan-lainnya.vue?vue&type=script&lang=js"

import "./page-layanan-lainnya.vue?vue&type=style&index=0&id=457d3894&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-457d3894"]])

export default __exports__